import React from 'react'
import ApexChart from 'react-apexcharts'

const UsageGauge = ({ percent }) => {
    const options = {
        chart: { type: 'radialBar', sparkline: { enabled: true } },
        colors: ['#6366F1'],
        plotOptions: {
            radialBar: {
                hollow: { size: '65%' },
                track: { background: '#e5e7eb' },
                dataLabels: {
                    name: { show: false },
                    value: {
                        fontSize: '28px',
                        fontWeight: 600,
                        formatter: (val) => `${val}%`
                    }
                }
            }
        },
        labels: ['Utilizado']
    }

    return (
        <ApexChart
            options={options}
            series={[percent]}
            type="radialBar"
            height={220}
        />
    )
}

export default UsageGauge
